import axios from "axios";
import { store } from "../redux/store";

export const axiosInstance = axios.create({
  baseURL: process.env?.REACT_APP_CURRENT_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});


axiosInstance.interceptors.response.use(
  function (res) {
    return res;
  },
  function (err) {
    const currentPath = window.location.pathname;
    const publicRoutes = ['/login', '/forgotpassword', '/resetpassword', '/'];
    const isPublicRoute = publicRoutes.includes(currentPath);
    
    if (
      (err?.response?.status === 401 || err?.response?.status === 403) &&
      !isPublicRoute
    ) {
      window.location.href = "/login";
      return Promise.reject(err);
    }
    
    return Promise.reject(err);
  }
);

axiosInstance.interceptors.request.use((req) => {
  const reduxStore = store?.getState();
  if (
    reduxStore?.common?.organization?.organization_id ||
    localStorage.getItem("organization_id")
  ) {
    req.headers["organization_id"] =
      reduxStore?.common?.organization?.organization_id ??
      localStorage.getItem("organization_id");
  }
  if (
    reduxStore?.common?.camp?.camp_details_id ||
    localStorage.getItem("camp_id")
  ) {
    req.headers["camp_details_id"] =
      reduxStore?.common?.camp?.camp_details_id ??
      localStorage.getItem("camp_id");
  }
  return req;
});
